import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { passwordValidator } from '../../../config/validators/password.validator';
import { HttpService } from '../../../services/http.service';
import { IChangePassword } from '../../../interfaces/change-password.interface';
import { AuthService } from '../../../services/auth.service';
import { ConfigService } from '../../../services/env-config.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChangePasswordComponent implements OnInit {
  editMode: boolean = false;
  formPassword: FormGroup = new FormGroup({});
  disabledMFA?: boolean;
  showSsoLink?: boolean;
  ssoUrl?: string;
  ssoRealm?: string;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private http: HttpService,
    private authService: AuthService,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.createFormPassword();
    this.configService.getConfig().subscribe((res: any) =>{
      console.log(res)
      this.disabledMFA  = res?.disabledMFA;
      this.ssoUrl = res?.ssoUrl;
      this.ssoRealm = res?.ssoRealm;
    });
    this.showSsoLink = this.authService.isSSOLogin();
  }

  private listenForm(): void {
    this.formPassword.valueChanges.subscribe((_) => {
      this.cdr.detectChanges();
    });
  }

  private createFormPassword(): void {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.,:;+_\-=!])[a-zA-Z\d.,:;+_\-=!]{8,16}$/;
    this.formPassword = this.fb.group(
      {
        old_password: [null, Validators.required],
        new_password: [null, [Validators.required, Validators.pattern(passwordRegex)]],
        confirm_password: [null, Validators.required],
      },
      {
        validators: passwordValidator('new_password', 'confirm_password'),
      }
    );
    this.listenForm();
  }

  protected onSave(): void {
    if (this.formPassword.valid) {
      const changePasswordPayload: IChangePassword = {
        newPassword: this.formPassword.get('new_password')?.value,
        oldPassword: this.formPassword.get('old_password')?.value,
        type: 'put',
      };
      this.http.changePassword(changePasswordPayload).subscribe((_) => {
        this.editMode = !this.editMode;
        this.formPassword.reset();
      });
    }
  }

  openLink(): void {
    const url = `${this.ssoUrl}realms/${this.ssoRealm}/account?referrer_uri=${encodeURIComponent(window.location.href)}`;
    window.location.href = url;
  }
}
